export const TurboStreamHeaders = (controller) => {
  Object.assign(controller, {
    turboStreamHeaders: () => ({
      Accept: "text/vnd.turbo-stream.html",
    }),
  });
};
